import { createPortal } from "react-dom";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from "@mui/material";
import Text from "../../styleguide/Text";
import SvgIcon from "../../helpers/SvgIcon";
import { ActionMenuTriggerContext } from "../actionMenu/ActionMenuTriggerContext";

type Props = {
  children: React.ReactNode;
  show: boolean;
  handleClose?: () => void;
  title?: string;
  modalSize?: "xs" | "sm" | "md" | "lg" | "xl";
  headerComponent?: (() => JSX.Element) | JSX.Element;
  actionsComponent?: (() => JSX.Element) | JSX.Element;
};

const modalsRoot = document.getElementById("root-modals") || document.body;

const ModalWrapper = ({
  children,
  show,
  handleClose,
  title,
  modalSize = "sm",
  headerComponent,
  actionsComponent,
}: Props): any => {
  return createPortal(
    <ActionMenuTriggerContext.Provider value={null}>
      <Dialog
        open={show}
        onClose={handleClose}
        maxWidth={modalSize}
        fullWidth
        scroll="body"
        sx={{ paddingTop: "70px" }}>
        {/* Header */}
        {(title || handleClose) && (
          <DialogTitle
            component="div"
            className="flex items-center justify-between">
            {title && (
              <Text
                variant="h2"
                component="h2"
                className="font-semibold text-slate-900">
                {title}
              </Text>
            )}
            {handleClose && (
              <IconButton
                onClick={handleClose}
                className="text-gray-500 hover:text-gray-900">
                <SvgIcon type="CLOSE_ICON" fill="currentColor" />
              </IconButton>
            )}
          </DialogTitle>
        )}

        {!!headerComponent && (
          <DialogTitle component="div">
            {typeof headerComponent === "function"
              ? headerComponent()
              : headerComponent}
          </DialogTitle>
        )}

        <DialogContent className="w-full border-t border-slate-200 !px-6 !py-6">
          {children}
        </DialogContent>

        {!!actionsComponent && (
          <DialogActions>
            {typeof actionsComponent === "function"
              ? actionsComponent()
              : actionsComponent}
          </DialogActions>
        )}
      </Dialog>
    </ActionMenuTriggerContext.Provider>,
    modalsRoot,
  );
};

export default ModalWrapper;
